export const KONFIRMASI_PENDAFTARAN = "KONFIRMASI_PENDAFTARAN";
export const REGISTRASI = "REGISTRASI";
export const PELAKU_USAHA_TERSELEKSI = "PELAKU_USAHA_TERSELEKSI";
